import styled from 'styled-components';

export const SalesDashboardContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const StatsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 16px;
    width: 100%;
`;

export const StatCard = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px;
    backdrop-filter: blur(10px);
`;

export const StatCardLabel = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 11px;
    letter-spacing: 0.2px;
    text-align: center;
    text-transform: uppercase;
`;

export const StatCardValue = styled.span`
    color: #FFFFFF;
    font-size: 22px;
    font-weight: 600;
    text-align: center;
`;

export const SectionHeader = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: space-between;
    width: 100%;
`;

export const SectionTitle = styled.h3`
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    letter-spacing: 0.2px;
    margin: 0;
    text-transform: uppercase;
`;

export const SectionCount = styled.span`
    color: rgba(255, 255, 255, 0.6);
    font-size: 12px;
`;

export const ListingsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 16px;
    width: 100%;
`;

export const EmptyState = styled.div`
    align-items: center;
    background: rgba(255, 255, 255, 0.05);
    border: 1px dashed rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    min-height: 180px;
    text-align: center;
    width: 100%;

    h2 {
        color: rgba(255, 255, 255, 0.8);
        font-size: 20px;
        margin: 0;
    }

    p {
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        margin: 0;
    }
`;

export const MessageState = styled.h3`
    color: rgba(255, 255, 255, 0.8);
    font-size: 16px;
    margin: 0;
`;
